import type { PropsWithChildren } from 'react';

import { useUserTrialDetails } from '@revelio/auth';

import { DataBuilderTrialPage } from './components/DataBuilderTrialPage';

export const DataBuilderRouteGuard = ({ children }: PropsWithChildren) => {
  const { isTrialUser } = useUserTrialDetails();

  // Hold render until trial status is known. With a boolean default, an
  // unresolved user reads as non-trial, the real page mounts, and it fires
  // GET /proxy/deliverables/ — which 500s for trial users.
  if (isTrialUser === null) {
    return null;
  }

  if (isTrialUser) {
    return <DataBuilderTrialPage />;
  }

  return children;
};
